export const AuthType = {
    Internal: 'INTERNAL',
    Saml: 'SAML',
    Ldap: 'LDAP',
    friendlyString(entry) {
        const map = {
            [this.Internal]: 'CloudConnexa',
            [this.Saml]: 'SAML',
            [this.Ldap]: 'LDAP',
        };
        return map[entry] || entry;
    },
};
export const UserRoleType = {
    Member: 'MEMBER',
    Owner: 'ENROLLED_OWNER',
    PendingOwner: 'OWNER',
    Admin: 'PRODUCT_ADMIN',
    GlobalConfigAdmin: 'G_CONFIG_ADMIN',
    BillingAdmin: 'BILLING_ADMIN',
    GlobalBillingAdmin: 'G_BILLING_ADMIN',
};
